export default __webpack_public_path__ + "static/media/mc-4-rMAX.8aa48cbb.avif";